/* tslint:disable:no-empty */
export function noop() { }



// WEBPACK FOOTER //
// ../../../../node_modules/src/util/noop.ts